import { useEffect, useState } from "react";
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { NoValidateForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Button, Col, Modal, Row } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import { assignInstaller, getLabInstallationItems, getLabInstallerItems, getParsicUser, newCenteralInstall } from "../../api/api";
import CustomSelect from "../../components/_common/CustomSelect";
import { useAppSelector } from "../../redux/store/storehooks";
import { confirmAlert } from "react-confirm-alert";
import "./style.css";
import { StyledTextArea } from "../../components/_common/CustomTextArea/styles";


export const AssignInstallerDialogRequestLab: React.FC<FormProps> = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {

    const { values, errors, handleChange, handleSubmit, setErrors, setValues } = useForm(NoValidateForm) as any
    const myStore = useAppSelector((state) => state)
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [parsicUserList, setParsicUserList] = useState();
    const [labInstallationItems, setLabInstallationItems] = useState([]);
    // const [labInstallationItemDesc, setLabInstallationItemDesc] = useState([{ id: 0, desc: "" }]);
    const [labInstallationItemDesc, setLabInstallationItemDesc] = useState<any>({});
    const [parsicUser, setParsicUser] = useState<any>({});
    const [assignToOne, setAssignToOne] = useState(false);
    const [installItems, setInstallItems] = useState<any>([]);
    

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type];
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect(() => {
        loadParsicUsers();
    }, [])


    const confirmAlertClick = (e: any) => {
        // setAccountStatusValue(Number(accountStatus));
        // setCurrentLicenseCount(Number(licenseCount));
        // setSelectedAccountId(Number(accountId));

        setValues((val: any) => ({
            ...val,
            parsicUser: e.target.value
        }))

        confirmAlert({
            title: "",
            message: "آیا میخواهید تمامی آیتم های نصب توسط این شخص انجام شود یا خیر؟",
            buttons: [
                {
                    label: "خیر",
                    onClick: () => {
                        setAssignToOne(false);
                        loadLabInstallationItems();
                        loadInstallerItems(payLoad.labId);
                    }

                },
                {
                    label: "بله",
                    onClick: () => {
                        setAssignToOne(true);
                        saveInstaller(e.target.value);
                        loadLabInstallationItems();
                        loadInstallerItems(payLoad.labId);
                    }
                }
            ]
        });
    };

    const loadParsicUsers = () => {

        getParsicUser()
            .then((result: any) => {
                setParsicUserList(result.data.data)
                setIsLoading(false);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })

    }

   

    const loadLabInstallationItems = () => {

        getLabInstallationItems()
            .then((result: any) => {
                setLabInstallationItems(result.data.data);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })

    }

    const loadInstallerItems = (labId:number) => {

        getLabInstallerItems(0,labId)
            .then((result: any) => {
                let arr:any = [];
                result.data.data.map((item:any)=>{
                    arr.push(item.str_DeliveryType)
                })
               setInstallItems(arr);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })
    }

    const _assignInstaller = (i: number, itemType: number) => {

        assignInstaller(assignToOne?Number(values.parsicUser):Number(parsicUser[i]), Number(myStore.auth.userId), itemType, payLoad.labId, labInstallationItemDesc[i])
            .then((result: any) => {
                sucessNotify("ثبت شد", undefined, 5000);
                loadLabInstallationItems();
                        loadInstallerItems(payLoad.labId);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })

    }

    function handleTextAreaChange(e: any) {
        const { id, value } = e.target;
        setLabInstallationItemDesc((prev: any) => ({ ...prev, [id]: value }));
    }
    function parsicUserClick(e: any) {
        const { name, value } = e.target;
        setParsicUser((prev: any) => ({ ...prev, [name]: value }));
    }

    

    // const handleTextAreaChange = (event: any) => {

    //     // const id = event.target.id;
    //     // const newValue = event.target.value;
    //     // const newArray = labInstallationItemDesc.map((v:any, i:any) => {
    //     //     if (i === id) return newValue;
    //     //     v.pus
    //     //     return v;
    //     //   });
    //     //   setLabInstallationItemDesc(newArray);


    //     const id = event.target.id;
    //    // var keys = Object.keys(labInstallationItemDesc);
    //      var desc =  JSON.parse(JSON.stringify(labInstallationItemDesc)).find((item: { id: any; })=>item.id ==id);
    //     if (desc !== null) {
    //         const newValue = event.target.value;
    //         const newArray = labInstallationItemDesc.map((v: any) => {
    //             if (v.id === id) return newValue;
    //         });
    //         setLabInstallationItemDesc(newArray);
    //     }
    //     //setLabInstallationItemDesc({ ...labInstallationItemDesc, [id]: event.target.value });
    //     else {
    //         var x = { id: id, desc: event.target.value };
    //         var a = [...labInstallationItemDesc];
    //         a.push(x);
    //         setLabInstallationItemDesc(a);
    //         // setLabInstallationItemDesc((labInstallationItemDesc: any) => [...labInstallationItemDesc, x]);

    //     }
    // }

    const saveInstaller = (userId:number) => {
        //e.preventDefault();

        setIsSubmiting(true)

        newCenteralInstall(
            medelMaper(userId)).then((result: any) => {
                sucessNotify("اطلاعات با موفقیت ثبت شد", undefined, 5000)
                //onCancel();
                setIsSubmiting(false)
            })
            .catch((error) => {
                console.log(error);
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }
    const medelMaper = (userId:number) => {
        let model: any = {}
        model.requestId = payLoad.requestId
        model.userId = userId
        model.ApproveuserId = myStore.auth.userId
        return model
    }

    return (
        <Modal footer={[]} width={600} title="نصاب آزمایشگاه"   style={{direction:'rtl'}}
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                    <Spinner />
                )}
                {isLoading === false && (

                    <div>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomSelect
                                    name="parsicUser"
                                    placeholder="نصاب آزمایشگاه"
                                    itemList={parsicUserList}
                                    value={values.parsicUser || ""}
                                    onChange={(e) => confirmAlertClick(e)}
                                    valueObjectField={"prk_ParsicUser_AutoID"}
                                    displayObjectField={"str_FullName"}
                                />
                               

                                <ValidationType type="parsicUser" />
                            </Col>
                        </Row>
                        {labInstallationItems !== undefined && labInstallationItems.length > 0 && (
                            labInstallationItems.map((item: any, index: number) => {
                                return (
                                    <Row style={{ display: "flex", justifyContent: "space-between", marginTop: "5px" }}>
                                        <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: "right" }}>
                                            {item.str_DeliveryType}
                                        </Col>
                                        {!assignToOne &&
                                            <Col lg={6} md={6} sm={24} xs={24}>
                                            <CustomSelect
                                                name={index.toString()}
                                                placeholder="نصاب آزمایشگاه"
                                                itemList={parsicUserList}
                                                value={parsicUser[index]}
                                                onChange={(e) => parsicUserClick(e)}
                                                valueObjectField={"prk_ParsicUser_AutoID"}
                                                displayObjectField={"str_FullName"}
                                            /></Col>
                                }
                                        <Col lg={11} md={11} sm={24} xs={24}>
                                            <StyledTextArea
                                                placeholder="توضیحات"
                                                name="description"
                                                id={index.toString()}
                                                className="input-field"
                                                onChange={(e) => handleTextAreaChange(e)}
                                                key={index.toString()}
                                                value={labInstallationItemDesc[index]}
                                            />
                                        </Col>
                                        <Col lg={2} md={2} sm={24} xs={24}>
                                            <Button disabled={installItems.includes(item.str_DeliveryType)} type="primary" style={{ backgroundColor: "Green" }} onClick={() => _assignInstaller(index, item.prk_DeliveryType_AutoID)} >ثبت</Button>
                                        </Col>
                                    </Row>
                                )
                            })
                        )}
                        


                    </div>
                   
                )}
            </>

        </Modal>
       

    )
}